import '@firebase/messaging-compat';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/compat/messaging/dist/index.esm.js
// module id = 580
// module chunks = 14